import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent {
  @Input() color: string;
  @Input() overrideMargins: boolean;
  @Input() infoText: string;

  constructor() {}
}
